'use client'

import { useSession } from 'next-auth/react'

import { MyProfileContent } from './MyProfileContent'

export function MyProfileModal() {
  const { data: session } = useSession()

  if (!session?.user?.uid) return null

  return <MyProfileContent variant="modal" />
}
